import { useQuery } from '@tanstack/react-query';

import useGameDetails from './useGameDetails.js';
import { PRICE_API_ALT_ENDPOINT } from 'const';


export function usePriceFeedURL(noAltURL) {
  const gameDetails = useGameDetails();

  const { data: priceFeedURL } = useQuery({
    queryKey: ['priceFeedURL', gameDetails?.tickerSymbol],
    queryFn: FetchPriceURL,
    placeholderData: null,
    refetchInterval: 0,
    staleTime: 1 * 60 * 60 * 1000,
    cacheTime: 4 * 60 * 60 * 1000,
  });

  async function FetchPriceURL() {
    if (!gameDetails.contracts.prediction) return null;
    let priceURL = await gameDetails.contracts.prediction.methods.priceSource().call();
    if (!priceURL)
      return null;
    priceURL = new URL(priceURL);
    //if (priceURL.host.includes('binance.us')) // debug
    if (noAltURL)
      priceURL = priceURL.toString();
    else if (priceURL.host.includes('binance.com'))
      priceURL = UseAltPriceURL(priceURL);
    else
      priceURL = priceURL.toString();
    return priceURL;
  }

  function UseAltPriceURL(defaultURL) {
    if (!defaultURL) throw new SyntaxError('missing required argument: defaultURL');
    let symbol = defaultURL.searchParams.get('symbol');
    symbol = symbol.replace('USDT', '');
    const altURL = PRICE_API_ALT_ENDPOINT + symbol;
    return altURL;
  }

  return priceFeedURL;
}


export function useCurrentPrice() {
  const gameDetails = useGameDetails();
  const priceFeedURL = usePriceFeedURL();

  const { data: currentPrice } = useQuery({
    queryKey: ['currentPrice', gameDetails?.tickerSymbol],
    queryFn: FetchCurrentPrice,
    structuralSharing: UseCachedPriceIfZeroPriceReturned,
    placeholderData: 0,
    refetchInterval: 1 * 1000,
    staleTime: 60 * 1000,
    cacheTime: 4 * 60 * 60 * 1000,
    retry: true,
    retryOnMount: true,
    notifyOnChangeProps: 'all'
  });

  async function FetchCurrentPrice() {
    if (!priceFeedURL) return 0;
    const options = {
      method: 'GET',
      headers: {
        //'Content-Type': 'application/json'
      },
    };
    const response = await fetch(priceFeedURL, options);
    const data = await response.json();
    const formattedPrice = Number(data.price).toFixed(gameDetails?.priceDecimals);
    return formattedPrice;
  }

  function UseCachedPriceIfZeroPriceReturned(oldPrice, newPrice) {
    if (newPrice == 0 && oldPrice != 0)
      return oldPrice;
    else
      return newPrice;
  }

  return currentPrice;
}
